import { migrateLegacyLocalStorage, type LegacyMigrationResult } from './legacy';
import { IndexedDbStudyRepository } from './repository';
import { inspectStorageHealth, requestPersistentStorage, type StorageHealth } from './storage';

export interface DataBootstrapResult {
  repository: IndexedDbStudyRepository;
  migration: LegacyMigrationResult;
  storage: StorageHealth;
  persistenceRequested: boolean;
}

/**
 * Safe application startup hook. It never requires a cloud connection and does not delete legacy data.
 */
export async function bootstrapStudyData(
  repository = new IndexedDbStudyRepository(),
): Promise<DataBootstrapResult> {
  const migration = await migrateLegacyLocalStorage(repository);
  const before = await inspectStorageHealth();
  let persistenceRequested = false;
  if (before.supported && !before.persisted) {
    persistenceRequested = true;
    await requestPersistentStorage();
  }
  const storage = await inspectStorageHealth();
  await repository.pruneSnapshots();
  return { repository, migration, storage, persistenceRequested };
}

